/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Tag,
  Typography,
  Dropdown,
  Checkbox,
  Divider,
  Button,
  Tooltip,
  Select,
} from "antd";
import { FilterOutlined, CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrBefore);

const { Text } = Typography;

const FiltroDropdown = ({
  filtroDropdownOpen,
  setFiltroDropdownOpen,
  filtroSucursales,
  setFiltroArticuloId,
  setFiltroArticuloSku,
  limpiarFiltros,
  sucursalesUnicas,
  setFiltroSucursales,
  tiposUnicos,
  filtroTipos,
  setFiltroTipos,
  filtroArticuloSku,
  opcionesFechaSma,
  filtroFecha,
  setFiltroFecha,
  filtroTransporte,
  handleTransporteCheck,
  transportesUnicos,
  darkMode,
}) => {
  const dropdownContent = (
    <div
      style={{
        padding: 16,
        width: "90vw",
        maxWidth: 360,
        minWidth: 280,
        maxHeight: "75vh",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "contain",
        touchAction: "pan-y",
        backgroundColor: darkMode ? "#1f1f1f" : "#fff",
        borderRadius: 10,
        boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
        position: "relative",
        boxSizing: "border-box",
      }}
      onClick={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <Button
        type="text"
        icon={<CloseOutlined style={{ fontSize: 19 }} />}
        onClick={() => setFiltroDropdownOpen(false)}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          color: darkMode ? "#bfbfbf" : "#888",
          zIndex: 10,
          minWidth: 24,
          width: 24,
          height: 24,
          padding: 0,
        }}
      />

      <Text
        strong
        style={{
          display: "block",
          marginBottom: 12,
          fontSize: 17,
          color: darkMode ? "#fff" : "#000",
        }}
      >
        Sucursal
      </Text>

      {filtroSucursales.length > 0 ? (
        <Checkbox.Group
          options={sucursalesUnicas}
          value={filtroSucursales}
          onChange={setFiltroSucursales}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            marginBottom: 16,
            fontSize: 16,
          }}
        />
      ) : (
        <Text type="secondary" style={{ fontSize: 15 }}>
          No hay sucursales disponibles
        </Text>
      )}

      <Divider
        style={{
          margin: "12px 0",
          backgroundColor: darkMode ? "#303030" : "#e8e8e8",
        }}
      />

      <Text
        strong
        style={{
          display: "block",
          marginBottom: 12,
          fontSize: 17,
          color: darkMode ? "#fff" : "#000",
        }}
      >
        Tipo de comprobante
      </Text>

      <Checkbox.Group
        options={tiposUnicos}
        value={filtroTipos}
        onChange={setFiltroTipos}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          marginBottom: 16,
          fontSize: 16,
        }}
      />

      {filtroArticuloSku && (
        <>
          <Divider
            style={{
              margin: "12px 0",
              backgroundColor: darkMode ? "#303030" : "#e8e8e8",
            }}
          />

          <Text
            strong
            style={{
              display: "block",
              marginBottom: 8,
              fontSize: 17,
              color: darkMode ? "#fff" : "#000",
            }}
          >
            Artículo filtrado
          </Text>

          <Tag
            closable
            onClose={(e) => {
              e.preventDefault();
              setFiltroArticuloId(null);
              setFiltroArticuloSku(null);
              //   valorTipeadoRef.current = "";
            }}
            color="blue"
            style={{
              fontSize: 16,
              padding: "6px 10px",
              marginBottom: 12,
              cursor: "pointer",
            }}
          >
            {filtroArticuloSku}
          </Tag>
        </>
      )}

      {/* ===== FECHA SMA ===== */}
      <Divider
        style={{
          margin: "12px 0",
          backgroundColor: darkMode ? "#303030" : "#e8e8e8",
        }}
      />

      <Text
        strong
        style={{
          display: "block",
          marginBottom: 12,
          fontSize: 17,
          color: darkMode ? "#fff" : "#000",
        }}
      >
        Fecha de Entrega
      </Text>

      <Checkbox.Group
        options={opcionesFechaSma}
        value={filtroFecha}
        onChange={setFiltroFecha}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          marginBottom: 16,
        }}
      />

      {/* ===== TRANSPORTE ===== */}
      <Divider
        style={{
          margin: "12px 0",
          backgroundColor: darkMode ? "#303030" : "#e8e8e8",
        }}
      />

      <Text
        strong
        style={{
          display: "block",
          marginBottom: 12,
          fontSize: 17,
          color: darkMode ? "#fff" : "#000",
        }}
      >
        Transporte
      </Text>

      <Checkbox.Group
        // Convertimos el valor a array para que Checkbox.Group lo entienda
        value={filtroTransporte !== undefined ? [filtroTransporte] : []}
        onChange={handleTransporteCheck}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      >
        {transportesUnicos.length === 0 ? (
          <Text type="secondary" style={{ fontSize: 15 }}>
            No hay transportes disponibles
          </Text>
        ) : (
          <>
            <Checkbox value={null}>Sin transporte</Checkbox>
            {transportesUnicos.map((t) => (
              <Checkbox key={t.value} value={t.value}>
                {t.label}
              </Checkbox>
            ))}
          </>
        )}
      </Checkbox.Group>

      <Divider
        style={{
          margin: "12px 0",
          backgroundColor: darkMode ? "#303030" : "#e8e8e8",
        }}
      />

      <Text
        strong
        style={{
          display: "block",
          marginBottom: 12,
          fontSize: 17,
          color: darkMode ? "#fff" : "#000",
        }}
      >
        Ruta
      </Text>
      <Select style={{ width: "100%" }} placeholder="Seleccionar una ruta" />

      <Divider
        style={{
          margin: "12px 0",
          backgroundColor: darkMode ? "#303030" : "#e8e8e8",
        }}
      />

      <Button
        type="link"
        size="large"
        onClick={limpiarFiltros}
        style={{
          padding: 0,
          fontSize: 17,
          height: "auto",
        }}
      >
        Limpiar filtros
      </Button>
    </div>
  );

  return (
    <Dropdown
      open={filtroDropdownOpen}
      onOpenChange={(open) => {
        if (open) setFiltroDropdownOpen(true);
      }}
      popupRender={() => dropdownContent}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Tooltip title="" placement="top">
        <div
          style={{
            width: 48,
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: darkMode ? "#262626" : "#fafafa",

            borderTop: `1px solid ${darkMode ? "#434343" : "#d9d9d9"}`,
            borderRight: `1px solid ${darkMode ? "#434343" : "#d9d9d9"}`,
            borderBottom: `1px solid ${darkMode ? "#434343" : "#d9d9d9"}`,
            borderLeft: "none",

            borderRadius: "0 8px 8px 0",
            cursor: "pointer",
            opacity: 1,
            position: "relative",
          }}
        >
          <FilterOutlined
            style={{
              color: darkMode ? "#bfbfbf" : "#8c8c8c",
              fontSize: 17,
            }}
          />
        </div>
      </Tooltip>
    </Dropdown>
  );
};

export default FiltroDropdown;
